"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

/* eslint-disable @typescript-eslint/no-unsafe-assignment */
const typesBundleTypes = [{
  minmax: [600, 699],
  types: {
    Address: 'LookupSource',
    LookupSource: 'IndicesLookupSource',
    TokenSymbol: {
      _enum: ['ACA', 'AUSD', 'DOT', 'XBTC', 'LDOT', 'RENBTC']
    }
  }
}, {
  minmax: [700, 719],
  types: {
    Address: 'GenericMultiAddress',
    LookupSource: 'GenericMultiAddress',
    TokenSymbol: {
      _enum: ['ACA', 'AUSD', 'DOT', 'XBTC', 'LDOT', 'RENBTC']
    }
  }
}, {
  minmax: [720, undefined],
  types: {
    Address: 'GenericMultiAddress',
    LookupSource: 'GenericMultiAddress'
  }
}];
var _default = typesBundleTypes;
exports.default = _default;